/**
 * Acciones para listar productos en la gestión de productos
 * gp_lp_ = Gestión de Productos (gp) _ Listar Productos (lp)
 */
import {Dispatch} from 'react'
import * as http from '../../../api/http'
import {ENDPOINTS} from '../../../api/config'
import {State} from '../../../reducers'
import {
  generalOpenModalError,
  generalOpenModalInfo,
  generalOpenModalMessage,
  generalShowLoader,
} from '../../general.actions'
import {GESTION_PRODUCTOS_TYPES} from '../../../constants/gestionProducto.types'
import {GestionProductoAction, GestionProducto} from '../../../interfaces/gestion-Productos.interfaces'
import {KEYS} from '../../../constants/keysStorage'
import { validacionesHandleChangeProducto, validacionesCodigoOnBlurProducto } from '../gp_generales.ts/gp_generales'
import {quitarAcentos} from '../../../utils/strings.utils'

// ******************************************************************************************
// ? ACTION CREATORS
// ******************************************************************************************
export const gp_lp_setArrayProductos = (productos: Array<any>) => ({
  type: GESTION_PRODUCTOS_TYPES.LP_SET_ARRAY_PRODUCTOS,
  payload: productos,
})

export const gp_lp_setProductos = (productos: Array<any>) => ({
  type: GESTION_PRODUCTOS_TYPES.LP_SET_PRODUCTOS,
  payload: productos,
})

export const gp_lp_HandleChangeFormBuscar = (form: any) => ({
  type: GESTION_PRODUCTOS_TYPES.LP_FORM_BUSCAR,
  payload: form,
})

export const gp_lp_ClearFormBuscar = () => ({
  type: GESTION_PRODUCTOS_TYPES.LP_CLEAR_FORM_BUSCAR,
  payload: null,
})

export const gp_lp_Clear = () => ({
  type: GESTION_PRODUCTOS_TYPES.LP_CLEAR,
  payload: null,
})

export const gp_lp_OpenModalEstatus = (flag: boolean) => ({
  type: GESTION_PRODUCTOS_TYPES.LP_SHOW_MODAL_ESTATUS,
  payload: flag,
})

export const gp_lp_OpenModalEliminarProducto = (flag: boolean) => ({
  type: GESTION_PRODUCTOS_TYPES.LP_SHOW_MODAL_ELIMINAR_PRODUCTO,
  payload: flag,
})

export const gp_lp_SetProductoSeleccionado = (producto: any) => ({
  type: GESTION_PRODUCTOS_TYPES.LP_SET_PRODUCTO_SELECCIONADO,
  payload: producto,
})

export const gp_lp_OpenModalSucursales = (flag: boolean) => ({
  type: GESTION_PRODUCTOS_TYPES.LP_SHOW_MODAL_SUCURSALES,
  payload: flag,
})

export const gp_lp_SetSucursales = (sucursales: any) => ({
  type: GESTION_PRODUCTOS_TYPES.LP_SET_SUCURSALES,
  payload: sucursales,
})

export const gp_lp_SetSucursalesSeleccionadas = (sucursales: Array<string>) => ({
  type: GESTION_PRODUCTOS_TYPES.LP_SET_SUCURSALES_ASIGNADAS,
  payload: sucursales,
})



// ******************************************************************************************
// ? FUNCIONES O PROCEDIMIENTOS SIN PETICIONES RES
// ******************************************************************************************
export const gp_lp_FormBuscarHandleChange =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
  async (dispatch: Dispatch<GestionProductoAction>) => {
    let {name, value} = e.target
    if (!validacionesHandleChangeProducto(name, value)) return
    dispatch(gp_lp_HandleChangeFormBuscar({[name]: value}))
  }

export const gp_lp_BuscarProducto =
  (flag: boolean = false) =>
  async (dispatch: Dispatch<GestionProductoAction>, getState: () => State) => {
    let arrayProductos = getState().gestionProducto.listarProductos.arrayProductos
    if (arrayProductos.length === 0 && !flag)
      return dispatch(generalOpenModalError('No se encontró el producto'))

    const {
      codigoProducto,
      precioUnitario,
      precioSinIVA,
      iva,
      tipoItem,
      unidadMedida,
      descripcion,
      impuestoDistintoAlIVA,
    } = getState().gestionProducto.listarProductos.formBuscar

    if (
      !codigoProducto &&
      !precioUnitario &&
      !precioSinIVA &&
      !iva &&
      !tipoItem &&
      !unidadMedida &&
      !descripcion &&
      !impuestoDistintoAlIVA
    ) {
      return dispatch(gp_lp_setProductos(arrayProductos))
    }

    let newProductos: Array<any> = []

    arrayProductos.forEach((producto) => {
      let encontrado = false
      if (codigoProducto)
        encontrado = quitarAcentos(producto?.codigoProducto).includes(
          quitarAcentos(codigoProducto)
        )
      if (precioUnitario)
        encontrado = producto?.precioUnitario.toString().includes(precioUnitario)
      if (precioSinIVA)
        encontrado = producto?.precioSinIVA.toString().includes(precioSinIVA)
      if (iva) encontrado = producto?.iva.toString().includes(iva)
      if (tipoItem)
    encontrado = producto?.servicioProducto?.toString() === tipoItem;

      if (unidadMedida)
        encontrado = quitarAcentos(producto?.unidadMedida).includes(
          quitarAcentos(unidadMedida)
        )
      if (descripcion)
        encontrado = quitarAcentos(producto?.descripcion).includes(
          quitarAcentos(descripcion)
        )
      if (impuestoDistintoAlIVA)
        encontrado = producto?.impuestoDistintoAlIVA.toString().includes(
          impuestoDistintoAlIVA
        )

      if (encontrado) newProductos.push(producto)
    })
    dispatch(gp_lp_setProductos(newProductos))
  }



// ******************************************************************************************
// ? PETICIONES RES
// ******************************************************************************************
 export const gp_lp_GetProductos = () => async (dispatch: Dispatch<any>, getState: () => State) => {
    if (getState().general.loader) return;
    dispatch(generalShowLoader(true));
    // Llamada directa a getProductos, sin recursión ni Promise.all
    await Promise.all([getProductos(dispatch), dispatch(gp_lp_getSucursales())])
    await await dispatch(generalShowLoader(false));
  };


const getProductos = async (dispatch: Dispatch<GestionProductoAction>, msg: string = '') => {
  const codigoempresa = localStorage.getItem(KEYS.CODIGO_EMPRESA);
  const username = localStorage.getItem(KEYS.USERNAME_CLIENTE);

  let message = msg || 'No se logró obtener información de los productos registrados.';
  await http
  
  .get(`${ENDPOINTS.GESTION_PRODUCTOS_GET_PRODUCTOS}?codigoempresa=${codigoempresa}&username=${username}`)

    .then(async (res: any) => {

      if (res?.data && Array.isArray(res.data)) {
        const productos = res.data

        if (productos.length > 0) {
          // Si quieres limpiar o transformar algo más, aquí lo haces
          const productosClean = productos.filter((p: any) => p?.codigoProducto);
          //const productosClean = res.data.filter((productos: any) => !productos?.descripcion?.split('~')[1])

          dispatch(gp_lp_setArrayProductos(productosClean));
          dispatch(gp_lp_setProductos(productosClean));
        } else {
          dispatch(gp_lp_setArrayProductos([]));
          dispatch(gp_lp_setProductos([]));
          dispatch(generalOpenModalInfo('No existen productos registrados'));
        }
        return;
      }

      dispatch(gp_lp_setArrayProductos([]));
      dispatch(gp_lp_setProductos([]));
      await dispatch(generalOpenModalError(message))
    })
    .catch(async (err: any) => {
      
      dispatch(gp_lp_setArrayProductos([]));
      dispatch(gp_lp_setProductos([]));
      
      await dispatch(
        
        generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status)
        
      )
      
    })
}

export const gp_lp_getSucursales = () =>
  async (dispatch: Dispatch<GestionProductoAction>, getState: () => State) => {
    const message = "Existió un inconveniente al obtener las sucursales";

    const state = getState();
    const idproducto = state.gestionProducto.listarProductos.productoSeleccionado?.idproducto;

    const body = { idproducto };

    await http
      .post(ENDPOINTS.GESTION_PRODUCTO_POST_SUCURSALES, body, {}, KEYS.TOKEN)
      .then(async (res: any) => {
        if (!res?.message) {
          dispatch(gp_lp_SetSucursales(res.body));
          return;
        }

        await dispatch(generalOpenModalError(res.message ?? message));
        dispatch(gp_lp_SetSucursales([]));
      })
      .catch(async (err: any) => {
        await dispatch(
          generalOpenModalError(
            err?.response?.data?.message ?? message,
            err?.response?.data?.status
          )
        );
        dispatch(gp_lp_SetSucursales([]));
      });
  };

export const gp_lp_EliminarProductoConfirm =
  () => async (dispatch: Dispatch<GestionProductoAction>, getState: () => State) => {

    if (getState().general.loader) return;
    await dispatch(generalShowLoader(true));

    const productoSeleccionado = getState().gestionProducto.listarProductos.productoSeleccionado;

    if (!productoSeleccionado || !productoSeleccionado.idproducto) {
      dispatch(generalOpenModalError("No hay producto seleccionado"));
      await dispatch(generalShowLoader(false));
      return;
    }

    const body = {
      idproducto: productoSeleccionado.idproducto
    };

    let message = "Existió un problema al eliminar el producto, inténtelo nuevamente";

    await http.put(ENDPOINTS.GESTION_PRODUCTO_DELETE_INFO, body)
      .then(async (res: any) => {
        if (res.status === 200) {
          await getProductos(dispatch, "Producto eliminado correctamente");

          dispatch(generalOpenModalMessage(
            `Producto Eliminado`,
            `El producto ha sido eliminado exitosamente`
          ));
          dispatch(gp_lp_ClearFormBuscar());
          dispatch(gp_lp_OpenModalEliminarProducto(false));
          dispatch(gp_lp_SetProductoSeleccionado(null));
          return;
        }
        dispatch(generalOpenModalError(res.message ?? message));
      })
      .catch((err: any) => {
        dispatch(generalOpenModalError(err?.response?.data?.message ?? message));
      })
      .finally(() => dispatch(generalShowLoader(false)));
  }


export const gp_lp_AsignarDesasignarSucurales =
  () => async (dispatch: Dispatch<any>, getState: () => State) => {
    const state = getState();

    if (state.general.loader) return;
    await dispatch(generalShowLoader(true));

    const sucursales = state.gestionProducto.listarProductos.sucursalesAsignadas;

    if (sucursales.length === 0) {
      dispatch(generalShowLoader(false));
      dispatch(generalOpenModalInfo(`Debe seleccionar al menos una sucursal al producto.`));
      return;
    }

    const productoSeleccionado = state.gestionProducto.listarProductos.productoSeleccionado;

    const body = {
  idproducto: productoSeleccionado.idproducto,
  productoSucursal: sucursales.map(idSucursal => ({ idsucursal: idSucursal }))
};

    let message = 'Existió un inconveniente al asignar las sucursales';

    await http
      .post(ENDPOINTS.GESTION_PRODUCTO_POST_ASIGNAR_SUCURSALES, body, {}, KEYS.TOKEN)
      .then(async (res: any) => {

        if (!res.message) {
          if (sucursales.length === 0) {
            dispatch(
              generalOpenModalMessage(
                `Asignación actualizada`,
                `El producto ha sido desvinculado de todas sus sucursales y no actualmente no puede realizar transacciones.`
              )
            )
          } else {
            dispatch(
              generalOpenModalMessage(
                `Asignación actualizada`,
                `Las sucursales asignadas al cliente fueron actualizadas correctamente.`
              )
            )
          }
          let message = 'Existió un inconveniente al actualizar la tabla de usuarios.'
          await getProductos(dispatch, message)
          dispatch(gp_lp_ClearFormBuscar())
          dispatch(gp_lp_OpenModalSucursales(false))
          dispatch(gp_lp_SetProductoSeleccionado(null))
          return
        }
        await dispatch(generalOpenModalError(res.message))
      })
      .catch(async (err: any) => {
        await dispatch(
          generalOpenModalError(
            err?.response?.data?.message ?? message,
            err?.response?.data?.status
          )
        )
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

export const gp_lu_changeEstatusProducto =
  () => async (dispatch: Dispatch<GestionProductoAction>, getState: () => State) => {
    if (getState().general.loader) return;
    await dispatch(generalShowLoader(true));

    const { productoSeleccionado } = getState().gestionProducto.listarProductos;

    if (!productoSeleccionado) {
      dispatch(generalOpenModalError("No hay producto seleccionado."));
      dispatch(generalShowLoader(false));
      return;
    }

    const estaActivo = productoSeleccionado.activo === "Activo";

    const username = localStorage.getItem(KEYS.USERNAME_CLIENTE);
    if (!username) {
      await dispatch(generalOpenModalError("No se pudo obtener el usuario actual."));
      dispatch(generalShowLoader(false));
      return;
    }

    const sucursalId =
      productoSeleccionado.sucursalesAsignadas?.length > 0
        ? productoSeleccionado.sucursalesAsignadas[0].idsucursal
        : null;

    const body: any = {
      idproducto: productoSeleccionado.idproducto,
      username,
      activo: !estaActivo
    };

    if (sucursalId) {
      body.idsucursal = sucursalId;
    }

    const messageErr = 'Existió un problema al cambiar el estado del producto, inténtelo nuevamente.'

    await http
      .put(ENDPOINTS.GESTION_PRODUCTO_PUT_ESTATUS, body)
      .then(async (res: any) => {
        if (res.status === 200) {
          await getProductos(dispatch);
          dispatch(
            generalOpenModalMessage(
              estaActivo ? 'Producto desactivado' : 'Producto activado',
              'El estado del producto se actualizó correctamente'
            )
          );
          await dispatch(gp_lp_OpenModalEstatus(false));
          return;
        }
        dispatch(generalOpenModalError(res.message ?? messageErr));
      })
      .catch((err: any) => {
        dispatch(
          generalOpenModalError(
            err?.response?.data?.message ?? messageErr,
            err?.response?.data?.status
          )
        );
      })
      .finally(() => dispatch(generalShowLoader(false)));
  };



